import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'tabla-busqueda',
  templateUrl: './tabla-busqueda.component.html',
  styleUrls: ['./tabla-busqueda.component.scss']
})
export class TablaBusquedaComponent implements OnInit {
  @Input() titulo:string|null=null
  @Input() lista:any[]=[]
  @Input() columnas:string[]=[]
  @Input() labels:string[]=[] //customizar los labels, las posiciones deben coincidir con las columnas
  @Input() contador:boolean=false
  @Input() selectable:boolean=false //define si las row son seleccionables y emite un evento con la tupla
  @Input() checkeable:boolean=false //define si las row son checkeables y emite un evento con la tupla / necesita que lo elementos incluyan el atributo check
  @Input() disabled:string|null=null //'Campo sobre el cual consulta para mostrar la fila como deshabilitada [disabled]'
  @Input() tdExtra: any = null //para agregar 1 campo al final de la tupla {th:'titulo columna', td:casilla}
  /**
   * Permite habilitar iconos en la ultima comulmna de la tabla, 
   * los cuales funcionan como botones que generan emiters
   * tdExtra{
   *  th: 'claseIcono titulo' ej: bi bi-plus-circle-fill
   *  td: 'claseIcono Celda' ej: bi bi-plus-lg
   *  all: 'todos los elementos cheackeados'
   * }
   *  iconos: https://icons.getbootstrap.com/
   *  cada tupla puede tener el atributo check para marcar en la tdExtra
   */
  @Output() selectTupla = new EventEmitter<any>()
  @Output() selectAll = new EventEmitter<any>()
  resultados:any[] = []
  allChecked:boolean = false
  
  constructor(public formulario: UntypedFormBuilder) { }

  /** formulario de búsqueda básico, por campos */
  formularioBusqueda=this.formulario.group({
    valor: new UntypedFormControl(''),
    campo: new UntypedFormControl(null)
  })

  ngOnInit(): void {
    this.reload()
  }
  ngOnChanges():void{
    this.buscar()
    this.labels = this.labels && this.labels.length > 0? this.labels : this.columnas
    this.allChecked = this.tdExtra?.all? this.tdExtra.all : false
    if(this.checkeable){
      this.tdExtra = this.tdExtra? this.tdExtra : {all:false}
      this.tdExtra.td = 'bi bi-circle'
      this.tdExtra.th = 'bi bi-circle'
    }
  }

  buscar(){
    this.resultados = this.lista? [...this.lista]:[]
    let form = this.formularioBusqueda.value
    form.valor = form.valor.trim()
    if(form.valor != '' && form.campo){
      let filtrado:any[]=[]
      this.lista.forEach(e => {
        let campo = typeof(e[form.campo])!='string'? e[form.campo].toString() : e[form.campo]
        if(campo.toLowerCase().includes(form.valor.toLowerCase())){
          filtrado.push(e)
        }
      });
      this.resultados=filtrado
    }
  }
  /** emision de todos los elementos */
  all(){
    this.selectAll.emit(this.resultados)
    this.allChecked = !this.allChecked
  }
  /**emision de una tupla a través del boton */
  put(tupla:any){
    if(this.selectable==false) this.selectTupla.emit(tupla)
  }
  /** emision de una tupla 'selectable' */
  select(tupla:any){
    if(this.selectable) this.selectTupla.emit(tupla)
      
  }
  reload(){
    this.formularioBusqueda.setValue({
      valor:'',
      campo: this.columnas?.length > 0? this.columnas[0] : null
    })
    this.resultados = this.lista? [...this.lista]:[]
  }


}
